import * as React from 'react';
import {
	Box,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
	ListItemIcon,
	Typography,
} from '@mui/material';

// 1. Category type definition
export type DataCategory = {
	id: number;
	label: string;
	icon: any;
	value?: string;
};

// 2. Props definition
export interface DataHubSidebarProps {
	categories: DataCategory[];
	onCategorySelect?: (category: DataCategory) => void; // Optional callback
}

export default function DataHubSidebar({ categories, onCategorySelect }: DataHubSidebarProps) {
	// Optionally, default to the first item
	const [selectedIndex, setSelectedIndex] = React.useState(
		categories.length ? categories[0].id : 0
	);

	const handleListItemClick = (id: number) => {
		setSelectedIndex(id);
		const selected = categories.find(c => c.id === id);
		if (selected && onCategorySelect) {
			onCategorySelect(selected);
		}
	};

	return (
		<Box sx={{ width: '100%' }}>
			<List component="nav" aria-label="main mailbox folders">
				{categories.map((category) => {
					const selected = selectedIndex === category.id;
					return (
						<ListItem
							key={category.id}
							disablePadding
						>
							<ListItemButton
								key={category.id}
								selected={selected}
								onClick={() => handleListItemClick(category.id)}
								sx={{
									borderLeft: selected ? '4px solid #1976d2' : '4px solid transparent',
									'&.Mui-selected, &.Mui-selected:hover': {
										bgcolor: "#e3f2fd",
										color: "primary.color",
										fontWeight: "bold",
									},
									'&:hover': {
										bgcolor: selected ? "#e3f2fd" : "#d3ebfc",
									}
								}}
							>
								<ListItemIcon
									sx={{ color: selected ? '#1976d2' : 'inherit', minWidth: 36 }}
								>
									{category.icon}
								</ListItemIcon>
								<ListItemText
									primary={
										<Typography
											sx={{
												color: selected ? '#1976d2' : 'inherit',
												fontWeight: selected ? 'bold' : 'normal',
											}}
										>
											{category.label}
										</Typography>
									}
								/>
							</ListItemButton>
						</ListItem>
					)
				}
				)}
			</List>
		</Box>
	);
}